import { connect } from 'react-redux';

import UnitProvider from '../components/UnitProvider';
import PropProvider from '../PropProvider';

export default connect(
  state => PropProvider(state).UnitProvider()
)(UnitProvider);
